module.exports = " <popup-picker :fixed-columns=\"hideDistrict ? 2 : 0\" :columns=3 :data=list :title=title :value.sync=value show-name :inline-desc=inlineDesc :placeholder=placeholder @on-hide=emitHide @on-show=\"$emit('on-show')\"></popup-picker> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/address/index.vue
// module id = 199
// module chunks = 2